import { IRequestWorkTime } from "../../../types/workTime.interface";
import customAxios from "../../customAxios";
import { FIND_WORK_TIME } from "../../routes";

const findWorkTime = async (props: IRequestWorkTime) => {
  var thisUrl = FIND_WORK_TIME + "?";
  if (props.page) thisUrl += `page=${props.page}`;
  if (props.limit) thisUrl += `&limit=${props.limit}`;

  try {
    return (await customAxios.get(thisUrl)).data;
  } catch (error: any) {
    console.log({ FIND_WORK_TIME: error });
  }
};

export default findWorkTime;
